import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AccountBalance, Agriculture, FamilyRestroom, FoodBank, Leaderboard } from '@mui/icons-material';
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';

import { MainCard, UserInfo } from 'components/home';
import { CardServico } from 'components/home/card_servico';
import { ROUTES } from 'routes/constants';
import PainelLogoImage from '../assets/images/home-logo-image.png';
import { ContainerPainel } from '../components/container_painel';

const HomePage: React.FC = () => {
  const [value, setValue] = useState(0);

  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <ContainerPainel>
      <Box
        sx={{
          backgroundColor: '#0048B6',
          height: '190px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'row',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '1200px', px: { xs: 2, sm: 3, md: 4 } }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: { xs: 2, sm: 0 },
              pt: { xs: 2, md: 0 },
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{
                sx: {
                  backgroundColor: '#FFFFFF',
                  bottom: 5,
                },
              }}
            >
              <Tab
                icon={<Leaderboard sx={{ color: '#FFFFFF' }} />}
                label='DASHBOARD'
                iconPosition='start'
                sx={{
                  minHeight: 5,

                  '&.Mui-selected': {
                    color: '#FFFFFF',
                  },
                }}
              />
            </Tabs>
            <UserInfo />
          </Box>

          <Box
            sx={{
              borderRadius: '16px',
              padding: '8px',
              backgroundColor: '#FFF',
              mt: 1,
            }}
            boxShadow='0px 1px 3px 0px #0000001F'
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Box
                component='img'
                src={PainelLogoImage}
                alt='Sistema Estadual Integrado da Agricultura Familiar'
                sx={{
                  width: { xs: '90%', sm: '70%', md: '60%' },
                  height: 'auto',
                }}
              />
            </Box>
            <Box mt={2}>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '20px',
                  fontWeight: 500,
                  lineHeight: '32px',
                  letterSpacing: '0.15px',
                  textAlign: 'center',
                }}
              >
                Gestão de Usuários
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20.02px',
                  letterSpacing: '0.17px',
                  textAlign: 'center',
                  color: '#00000099',
                }}
              >
                Crie, altere, exclua, e visualize todos os dados dos usuários do
                sistema.
              </Typography>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingTop: '10px',
                }}
              >
                <MainCard
                  navigate={navigate}
                  onAccess={() => navigate(ROUTES.MENU_USER)}
                />
              </Box>
            </Box>
          </Box>

          <Stack
            mt='1.5rem'
            direction={{ md: "row", sm: "column" }}            // flexWrap='wrap'
            justifyContent='center'
            gap='1rem'
            sx={{ pb: 4 }}
          >
            <CardServico
              icone={<AccountBalance />}
              titulo='Módulo Prefeitura'
              descricao='Realize o gerenciamento dos formulários do módulo prefeitura no sistema.'
              irPara={ROUTES.PACOTE_FORMULARIOS}
            />
            <CardServico
              icone={<FoodBank />}
              titulo='Módulo Estabelecimentos da AF'
              descricao='Realize o cadastro de informações da cooperação e associativismo para a agricultura familiar.'
              irPara={ROUTES.CICAAF}
            />
            <CardServico
              icone={<FamilyRestroom />}
              titulo='Módulo Unidades Familiares'
              descricao='Realize o cadastro único de famílias da agricultura familiar - CUFFA.'
              irPara={ROUTES.CUFFA}
            />
            <CardServico
              icone={<Agriculture />}
              titulo='Módulo IAF (CIFA)'
              descricao='Gerencie todos os dados sobre o CIFA disponíveis no sistema.'
              irPara={ROUTES.MANAGE_SERVICE}
            />
          </Stack>
        </Box>
      </Box>
    </ContainerPainel>
  );
};

export default HomePage;
